import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ModalCardComponent } from '@components/Modals/modal-card/modal-card.component';

@Component({
  selector: 'app-modal-insufficient-balance',
  standalone: true,
  imports: [ModalCardComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-insufficient-balance.component.html',
})
export class ModalInsufficientBalanceComponent {
  title = input.required<string>();
  currentBalanceLabel = input.required<string>();
  currentBalanceAmount = input.required<string>();
  requiredAmountLabel = input.required<string>();
  requiredAmountAmount = input.required<string>();
  backToSelectionLabel = input.required<string>();
  saveAndBackLabel = input.required<string>();
  forcePassageLabel = input.required<string>();

  backToSelectionClick = output<void>();
  saveAndBackClick = output<void>();
  forcePassageClick = output<void>();
}
